import { useEffect } from 'react';
import { useAppDispatch } from 'store/hooks';
import playlistSelectors from '../selectors';
import playlistActions from '../actions';

const useGetDetailPlaylist = (playlistId: string, lazy = false) => {
  const dispatch = useAppDispatch();
  const data = playlistSelectors.getDetailPlaylist();

  const mutate = (playlistId: string) => {
    dispatch(playlistActions.getDetailPlaylist.fetch(playlistId));
  };

  useEffect(() => {
    if (playlistId && !lazy) {
      mutate(playlistId);
    }
  }, [playlistId]);

  return [data, mutate] as const;
};

export default useGetDetailPlaylist;
